export const PRICE_PRIORITY = [
  'bestPrice',
  'instantShip',
  'newWithDefects',
  'newWithBoxIssues',
  'used',
];
